// extracted by mini-css-extract-plugin
export var heroImage = "_kg-1";
export var modal = "_kg-0";